import React from 'react';
import { PageHero } from '../components/PageHero';
import { PortfolioGrid } from '../components/PortfolioGrid';
import { images } from '../data/images';
import { portfolio } from '../data/portfolio';
export function Portfolio() {
  return <>
      <PageHero title="See The Skills" subtitle="Portfolio" image={images.knight} data-id="element-370" data-mp="2kpj0utuevbh7">
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-371" data-mp="2fv54op7xd0bh">Here are the glimpse of exponential work done by the Tattoo Artists</p>
      </PageHero>
      <section className="mx-auto max-w-[1400px] px-1 py-16" aria-label="Tattoo portfolio" data-id="element-372" data-mp="2pnav3uij39ok">
        <PortfolioGrid items={portfolio} data-id="element-373" data-mp="33mk86lbftnob" />
      </section>
    </>;
}